import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

const CostBreakdownChart = ({ formData }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const chart = echarts.init(chartRef.current);

    const foodCosts = parseFloat(formData.foodCosts) || 0;
    const laborCosts = parseFloat(formData.laborCosts) || 0;
    const rentUtilities = parseFloat(formData.rentUtilities) || 0;
    const otherExpenses = parseFloat(formData.otherExpenses) || 0;

    const data = [
      {
        value: foodCosts,
        name: 'Food & Beverage',
        itemStyle: { color: '#f97316' }
      },
      {
        value: laborCosts,
        name: 'Labor Costs',
        itemStyle: { color: '#3b82f6' }
      },
      {
        value: rentUtilities,
        name: 'Rent & Utilities',
        itemStyle: { color: '#8b5cf6' }
      },
      {
        value: otherExpenses,
        name: 'Other Expenses',
        itemStyle: { color: '#64748b' }
      }
    ].filter(item => item.value > 0);

    const option = {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: RM{c} ({d}%)',
        backgroundColor: 'rgba(255,255,255,0.95)',
        borderColor: '#e2e8f0',
        borderWidth: 1,
        textStyle: { color: '#334155' }
      },
      legend: {
        orient: 'horizontal',
        bottom: '0%',
        textStyle: { color: '#64748b', fontSize: 12 }
      },
      series: [
        {
          name: 'Costs',
          type: 'pie',
          radius: ['40%', '70%'],
          center: ['50%', '45%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 8,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 16,
              fontWeight: 'bold',
              color: '#1e293b'
            },
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0,0,0,0.5)'
            }
          },
          labelLine: {
            show: false
          },
          data: data
        }
      ]
    };

    chart.setOption(option);

    const handleResize = () => {
      chart.resize();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      chart.dispose();
    };
  }, [formData]);

  return (
    <div>
      <div ref={chartRef} style={{ width: '100%', height: '300px' }} />
      {(!formData.foodCosts && !formData.laborCosts && !formData.rentUtilities && !formData.otherExpenses) && (
        <div className="text-center text-slate-500 py-8">
          <p>Enter your cost data to see the breakdown chart</p>
        </div>
      )}
    </div>
  );
};

export default CostBreakdownChart;